<template>
  <Multiselect
    :allow-empty="false"
    :searchable="true"
    :mode="mode"
    label="title"
    value-prop="id"
    placeholder="Make selection"
    :options="options"
    :native-support="true"
    :value="modelValue"
    v-bind="$attrs"
    :class="`multiselect-${size}`"
    @input="$emit('update:modelValue', $event)">
    <template #singlelabel="option">
      <slot name="singlelabel" :option="option.value" />
    </template>
    <template #option="option">
      <slot name="option" :option="option.option" />
    </template>
    <template #placeholder>
      <slot name="placeholder" />
    </template>
    <template #multiplelabel="option">
      <slot name="multiplelabel" :option="option.values" />
    </template>
  </Multiselect>
</template>

<script setup>
import Multiselect from '@vueform/multiselect'

defineProps({
  id: { type: String, required: true },
  options: { type: [Array, Object], required: true },
  mode: { type: String, default: 'single' },
  modelValue: {
    required: true,
    validator: (prop) => ['string', 'object', 'number', 'array', 'undefined'].includes(typeof prop) || prop === null
  },
  size: {
    type: String,
    required: false,
    default: 'default',
    validator: (prop) => ['default', 'lg', 'sm'].includes(prop)
  }
})

defineEmits(['update:modelValue'])
</script>
